<template>
  <div>
    <university-division-index
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :title="$t('menu.university_division_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import UniversityDivisionIndex from "./UniversityDivisionIndex";
export default {
  name: "Index",
  data() {
    return {
      serviceName: "university-divisions",
      formSearch: [
        {
          label: this.$t("university_division.name"),
          name: "name__~",
          value: "",
          type: "input"
        }
      ],
      columns: {
        id: this.$t("university_division.id"),
        name: this.$t("university_division.name"),
        description: this.$t("university_division.description"),
        created_at: this.$t("university_division.created_at"),
        updated_at: this.$t("university_division.updated_at")
      }
    };
  },
  components: { UniversityDivisionIndex },
  methods: {},
  mounted() {}
};
</script>
